import { AHTeamIconCircle, Box, SectionHeader } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";

export function RoutineOccasionSectionHeader(props: {
  routineOccasionSection: any;
}) {
  const {
    sectionVersion,
    section: { assignedTeam },
  } = useFragment(
    graphql`
      fragment RoutineOccasionSectionHeader_routineOccasionSection on RoutineOccasionSection {
        id
        section {
          id
          assignedTeam {
            id
            name
            icon
            color
            isPrivate
          }
        }
        sectionVersion {
          id
          title
        }
      }
    `,
    props.routineOccasionSection
  );
  if (
    (sectionVersion.title && sectionVersion.title.length > 0) ||
    assignedTeam
  ) {
    return (
      <Box spaceHorizontal="medium">
        <SectionHeader
          left={
            assignedTeam ? (
              <AHTeamIconCircle
                size="smallMedium"
                color={assignedTeam.color}
                type={assignedTeam.icon}
                isPrivate={assignedTeam.isPrivate}
              />
            ) : null
          }
        >
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <SectionHeader.Title>
              {sectionVersion.title && sectionVersion.title.length > 0
                ? sectionVersion.title
                : (assignedTeam?.name ?? "")}
            </SectionHeader.Title>
          </Box>
          {assignedTeam &&
          sectionVersion.title &&
          sectionVersion.title.length > 0 ? (
            <SectionHeader.Description>
              <FormattedMessage
                defaultMessage="Assigned to: {assignedTeamName}"
                description="RoutineOccasionScreen section assigned to title"
                values={{ assignedTeamName: assignedTeam.name }}
              />
            </SectionHeader.Description>
          ) : null}
        </SectionHeader>
      </Box>
    );
  }
  return null;
}
